import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import Select from "Components/common/Select/Select";

@connect(store => {
    return {
        files: store.files
    };
})

class Action extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            options: [
                {value: null, label: "Select"},
                {value: "created", label: "Upload File/Create folder"},
                {value: "commented", label: "Comment"},
                {value: "tagged", label: "Add/Edit Tagged Workstream"},
                {value: "duplicated", label: "Duplicate"},
                {value: "modified", label: "Rename"},
                {value: "restored", label: "Restored"},
                {value: "granted", label: "Grant Folder Access"},
                {value: "removed", label: "Remove Folder Access"},
                {value: "moved", label: "Move Files/Folder"},
                {value: "clone", label: "Duplicated File"},
                {value: "deleted", label: "Delete / Permanent Delete"}

            ]
        }
    }

    render() {
        const { dispatch, files } = this.props;

        const handleSelect = (value) => {
             dispatch({ type: "UPDATE_FILES_FILTERS", filters: {action: value} });
        }

        return (
            <div class="optionRow">
                <span>Action</span>
                <div class="optionChoices">
                    <Select 
                        classes={{options: "filesFilterOptions"}}
                        options={this.state.options}
                        placeholder="Select"
                        onChange={handleSelect}
                        selected={files.filters.options.action}
                        isClose={files.filters.isCleared}
                    />
                </div>
            </div>
        );
    }
}

export default Action;